let guidance_api = 'https://jszwzt.jszwfw.gov.cn:8083/dist/yjsguidance/js/guidance.js'; // 第三方组件
let loginURL = 'https://www.jszwfw.gov.cn/jsjis/front/login.do?uuid=xXCe2uTFA2tS'
let endServers; // 后端接口
endServers = {
    hlw: 'http://49.77.204.30:18000/hotelonething/hlw', // 新点接口
    hotel: 'http://49.77.204.30:18000/hotelonething/hotel', // 汪鑫
    file: 'http://49.77.204.30:18000/hotelonething/file', // 下载文件
}

module.exports = {
    guidance_api,
    endServers,
    loginURL
}


//////////////////
// WEBPACK FOOTER
// ./vue.dev.js
// module id = SgpG
// module chunks = 2